let Enums = {
    endPoints: {
        "/getUser" : "Kullanıcılar Getirildi.",
        "/startCompanySession" : "startCompanySession Adlı endPoint",
        "/getUserPermission" : "getUserPermission Adlı endPoint",
        "/logOut" : "Kullanıcı Çıkış Yaptı."
    },
    "requestType" : {
        "GET" : "GET",
        "POST" : "POST",
        "PUT" : "PUT"
    },
}

module.exports = Enums;